import React, { useEffect, useState } from "react";
import axios from "axios";
import Pending from "../../../../../../assets/images/rightSign.png";
import AllDataHeader from "../../../../../Reuseable/AllDataHeader";
import LoaderPost from "../../../../../Reuseable/LoaderPost";
import AllModuleData from "../../../../../Reuseable/AllModuleData";

const CompletedMeetupList = () => {
  const [event_data, setMeetupEvents] = useState([]);
  const [count, setCount] = useState(0);

  const [buffer, setBuffer] = useState(true);

  useEffect(() => {
    axios.get(`/api/admin/meetup_event/completed`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setMeetupEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
       <AllDataHeader
        title="Complete Meetup Events"
        image={Pending}
        count={count}
      />
      {buffer ? (
        <LoaderPost/>
      ) : (
        <AllModuleData
          data={event_data}
          urlLink={`/superstar-admin/meetup-events/pending`}
        />
      )}
    </>
  );
};

export default CompletedMeetupList;
